module.exports = __webpack_public_path__ + "assets/img/onboarding_3.b6fea916.png";